module.exports = __webpack_public_path__ + "img/stop-3.5ec95d1a.jpg";